import {
  formatCurrency,
  formatFloat,
  getProgressPercentageOfCompletion,
  sortedArrayByObjectKeys,
} from "../../../services/utils";

export function transformDataToFormModel(data) {
  const score = {
    consulted_at: data?.score_consulted_at,
    expired: data?.score_expired
  }

  return {
    id: data.id || null,
    title: data.title || null,
    cnpj: data.cnpj || null,
    created_at: data.created_at || null,
    is_finished: data.is_finished || false,
    isShared: data.is_shared || false,
    planner: data.planner || null,
    lastStepSaved: data.data?.lastStepSaved || 1,
    results: {...data.results, recommendations: data?.recommendations} || null,
    invites: data.invites || [],
    score_serasa: score,
    opinion: data.opinion || null,
    step1: {
      title: data.title || "",
      // objective: data.objective || "",
      score: data.score || "",
    },
    step2: {
      cif: formatCurrency(data.data?.cif) || 0,
      cmp: formatCurrency(data.data?.cmp) || 0,
      cms: formatCurrency(data.data?.cms) || 0,
      rtp: formatCurrency(data.data?.rtp) || 0,
      rts: formatCurrency(data.data?.rts) || 0,
    },
    step3: {
      cc: {
        pdt: formatCurrency(data.data?.cc?.pdt) || 0,
        pdrt: formatCurrency(data.data?.cc?.pdrt) || 0,
      },
      ci: {
        pdt: formatCurrency(data.data?.ci?.pdt) || 0,
        pdrt: formatCurrency(data.data?.ci?.pdrt) || 0,
      },
      ou: {
        pdt: formatCurrency(data.data?.ou?.pdt) || 0,
        pdrt: formatCurrency(data.data?.ou?.pdrt) || 0,
      },
      tcc: {
        pdt: formatCurrency(data.data?.tcc?.pdt) || 0,
        pdrt: formatCurrency(data.data?.tcc?.pdrt) || 0,
      },
      tcd: {
        pdt: formatCurrency(data.data?.tcd?.pdt) || 0,
        pdrt: formatCurrency(data.data?.tcd?.pdrt) || 0,
      },
    },
    step4: {
      cgp: formatCurrency(data.data?.cgp) || 0,
      iif: formatCurrency(data.data?.iif) || 0,
    },
    step5: data.data?.pdr?.length
      ? sortedArrayByObjectKeys(data.data?.pdr)
      : [],
    step6: data.data?.pdc?.length
      ? sortedArrayByObjectKeys(data.data?.pdc)
      : [],
    step7: data.data?.gde?.length
      ? sortedArrayByObjectKeys(data.data?.gde).map((item) => {
          return {
            ...item,
            value: formatCurrency(item.value),
          };
        })
      : [{ order: 0, days: "", value: 0 }],
    step8: {
      VGdQV: formatCurrency(data.data?.VGdQV) || 0,
      VGdPV: formatCurrency(data.data?.VGdPV) || 0,
      VGdQV_just: data.data?.VGdQV_just || "",
      VGdPV_just: data.data?.VGdPV_just || "",
      goal_date: data.data?.goal_date || null,
      title: data.title || null,
    },
    step9: data.data?.fluxo || null,
    // step10: {
    //   financingValue: formatCurrency(data.fampe?.financing_value) || 0,
    //   guaranteesValue: formatCurrency(data.fampe?.guarantees_value) || 0,
    //   company_size: selectedCompany?.id || 99,
    //   percent: data.fampe?.percent || 0.8
    // }
  };
}
export function isStepCompleted(data, ignoreFields = [], options = {}) {
  if (!data || typeof data !== "object") return false;

  if (ignoreFields.includes("*")) {
    return true;
  }

  if (options.requireSum100 && Array.isArray(data)) {
    return validateSum100(data);
  }

  if (options.inventoryTurnover && Array.isArray(data)) {
    return validateInventoryTurnover(data);
  }

  for (const key in data) {
    if (ignoreFields.includes(key)) {
      continue;
    }

    const value = data[key];

    if (typeof value === "object" && value !== null) {
      const nestedCompleted = isStepCompleted(value, ignoreFields, options);
      if (!nestedCompleted) {
        return false;
      }
    } else if (typeof value === "string" && value.trim() === "") {
      return false;
    } else if (typeof value === "number" && value === 0) {
      return false;
    } else if (value === null || value === undefined) {
      return false;
    }
  }

  return true;
}
export function deepCompare(obj1, obj2) {
  if (obj1 === obj2) return true;

  if (typeof obj1 !== typeof obj2) return false;

  if (typeof obj1 !== "object" || obj1 === null || obj2 === null) {
    return obj1 === obj2;
  }

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return false;
    for (let i = 0; i < obj1.length; i++) {
      if (!deepCompare(obj1[i], obj2[i])) {
        return false;
      }
    }
    return true;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!deepCompare(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
export function hasDuplicates(array) {
  const seen = new Set();
  for (const item of array) {
    const days = Number(item.days) || 0;
    if (days !== 0 && seen.has(days)) {
      return true;
    }
    seen.add(days);
  }
  return false;
}
export function validateSum100(data) {
  const sum = data.reduce((acc, item) => acc + (Number(item.value) || 0), 0);
  return sum === 100;
}
export function validateInventoryTurnover(data) {
  let total = 0;

  for (const item of data) {
    const days = Number(item.days) || 0;
    const value = formatFloat(item.value) || 0;

    total += value;

    const hasDays = days >= 0;
    const hasValue = value > 0;

    if ((hasDays && !hasValue) || (!hasDays && hasValue)) {
      return false;
    }
  }

  return total === 100 && !hasDuplicates(data);
}
function parseMoneyString(value) {
  if (typeof value === "string") {
    const numericValue = value
      .replace(/[^\d,-]/g, "")
      .replace(/\.(?=\d{3,})/g, "")
      .replace(",", ".");

    const parsed = parseFloat(numericValue);

    return !isNaN(parsed) ? parsed : value;
  }

  return typeof value === "number" ? value : 0;
}
function deepParseValues(obj) {
  const ignoreFields = [
    // "mesBase",
    // "objective",
    "uuid",
    "title",
    "mes",
    "goal_date",
    "VGdQV_just",
    "VGdPV_just",
    "data_inicial",
    "data_final",
  ];
  if (Array.isArray(obj)) {
    return obj.map((item) => deepParseValues(item));
  }
  if (typeof obj === "object" && obj !== null) {
    const parsed = {};
    for (const [key, value] of Object.entries(obj)) {
      let newValue = deepParseValues(value);
      if (key === "days") {
        newValue = value === "" ? 0 : value;
      }
      if (key === "mesBase") {
        newValue = value;
      }
      if (ignoreFields.includes(key)) {
        newValue = value;
      }
      parsed[key] = newValue;
    }
    return parsed;
  }
  return parseMoneyString(obj);
}
export function formatPlanningDataForSave(rawData, currentStep) {
  const data = {};

  for (let i = 2; i <= 10; i++) {
    const stepKey = `step${i}`;
    if (rawData[stepKey]) {
      let mappedKey = stepKey;
      if (stepKey === "step5") mappedKey = "pdr";
      if (stepKey === "step6") mappedKey = "pdc";
      if (stepKey === "step7") mappedKey = "gde";
      if (stepKey === "step9") mappedKey = "fluxo";

      const parsedStep = deepParseValues(rawData[stepKey]);

      if (["pdr", "pdc", "gde", "fluxo"].includes(mappedKey)) {
        data[mappedKey] = parsedStep;
      } else {
        if (typeof parsedStep === "object" && parsedStep !== null) {
          Object.assign(data, parsedStep);
        }
      }
    }
  }

  data.lastStepSaved = rawData.lastStepSaved >= currentStep ? rawData.lastStepSaved : currentStep;

  return {
    cnpj: rawData.cnpj || null,
    title: rawData.step1?.title || "",
    // objective: rawData.step1?.objective || "",
    score: rawData.step1?.score || 0,
    is_finished: rawData.is_finished ?? false,
    data,
    results: rawData.results,
    progress_percentage: getProgressPercentageOfCompletion(data?.lastStepSaved, rawData.is_finished ?? false)
  };
}
export function updateNestedKey(obj, path, value) {
  const keys = path.split(".");
  const lastKey = keys.pop();
  const newObj = { ...obj };
  let nested = newObj;

  for (const key of keys) {
    if (!(key in nested)) nested[key] = {};
    nested[key] = { ...nested[key] };
    nested = nested[key];
  }
  nested[lastKey] = value;
  return newObj;
}
export function hasZeroValue(obj) {
  const parseValue = (val) => {
    if (typeof val === "string") {
      const clean = val
        .replace(/\./g, "")
        .replace(",", ".")
        .replace(/[^\d.-]/g, "");
      return parseFloat(clean);
    }
    return typeof val === "number" ? val : NaN;
  };

  const check = (data) => {
    for (const key in data) {
      const value = data[key];
      if (typeof value === "object" && value !== null) {
        if (check(value)) return true;
      } else {
        const parsed = parseValue(value);
        if (!isNaN(parsed) && parsed === 0) {
          return true;
        }
      }
    }
    return false;
  };

  return check(obj);
}

export const colorsProgressBar = [
  {
    background: "#D0DCFF",
    bar: "#2E5DE6",
  },
  {
    background: "#FCDECF",
    bar: "#FF8040",
  },
  {
    background: "rgba(146, 133, 249, 0.30)",
    bar: "#9285F9",
  },
  {
    background: "#C5E19E",
    bar: "#547A1F",
  },
  {
    background: "#CFE2FC",
    bar: "#14ADCC",
  },
  {
    background: "#EDE5DE",
    bar: "#463320",
  },
  {
    background: "#FFE380",
    bar: "#8F6B24",
  },
  {
    background: "#D4F7ED",
    bar: "#00805C",
  },
  {
    background: "#F0DBF0",
    bar: "#994599",
  },
  {
    background: "rgba(189, 231, 255, 0.40)",
    bar: "#005EB8",
  },
  {
    background: "#D4DADD",
    bar: "#61686B",
  },
  {
    background: "#F3D8DA",
    bar: "#BF303C",
  },
  {
    background: "#CFE2FC",
    bar: "#0F438A",
  },
];
